import api from "../api";

// Uploads a file directly to Supabase Storage using a short-lived signed upload URL
// (bypasses backend/proxy body-size limits). Returns attachment metadata.
export async function uploadTrainingAsset(file, kind) {
  const { data } = await api.post("/admin/training/upload-url", { filename: file.name, kind });
  if (data.max_mb && file.size > data.max_mb * 1024 * 1024) {
    throw new Error(`File exceeds the ${data.max_mb} MB limit.`);
  }
  const res = await fetch(data.upload_url, {
    method: "PUT",
    headers: { "content-type": file.type || "application/octet-stream", "x-upsert": "true" },
    body: file,
  });
  if (!res.ok) {
    const t = await res.text().catch(() => "");
    throw new Error(`Upload failed (${res.status}). ${t}`);
  }
  return { kind, name: data.name, path: data.path, url: data.public_url, content_type: file.type, size: file.size };
}
